module.exports = __webpack_public_path__ + "static/assets/d655fabfd8b977e0826509f1a4f7cf38.svg";